import { render, staticRenderFns } from "./image-displayer.vue?vue&type=template&id=13cc7908&scoped=true&"
import script from "./image-displayer.vue?vue&type=script&lang=js&"
export * from "./image-displayer.vue?vue&type=script&lang=js&"
import style0 from "./image-displayer.vue?vue&type=style&index=0&id=13cc7908&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cc7908",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/nuxt-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13cc7908')) {
      api.createRecord('13cc7908', component.options)
    } else {
      api.reload('13cc7908', component.options)
    }
    module.hot.accept("./image-displayer.vue?vue&type=template&id=13cc7908&scoped=true&", function () {
      api.rerender('13cc7908', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/template/form/image-displayer.vue"
export default component.exports